export const createContextualQuery = (
  articleTitle: string,
  articleText: string,
  userQuery: string
): string => {
  return `The user is currently reading an article, here is the article they are reading
${articleTitle}: ${articleText}
Here is the follow up question the user would like you to answer based on this article
${userQuery}`;
};
